import React from 'react';
import { Moon, Sun, SunDim } from 'lucide-react';

/* Light-behaviour controls matched to the selected fabric type */
export const LightControls = ({ light, filterOpacity, setFilterOpacity, openness, setOpenness }) => {
  if (!light) return null;

  if (light.mode === 'blackout') {
    return (
      <div className="flex items-start gap-3 rounded-xl bg-neutral-900 text-white p-3.5" data-testid="light-blackout-badge">
        <Moon className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium">Blackout fabric</p>
          <p className="text-[11px] text-neutral-300 mt-0.5">0% light transmission — no light or shadows pass through the shade.</p>
        </div>
      </div>
    );
  }

  if (light.mode === 'screen') {
    return (
      <div className="space-y-2" data-testid="openness-controls">
        <div className="flex items-center gap-2">
          <Sun className="w-4 h-4 text-amber-500" />
          <label className="text-[11px] text-neutral-500 uppercase tracking-wider font-medium">Openness Factor</label>
        </div>
        <div className="grid grid-cols-4 gap-1.5">
          {[1, 3, 5, 10].map(pct => {
            const available = light.options.includes(pct);
            const active = openness === pct;
            return (
              <button
                key={pct}
                type="button"
                disabled={!available}
                onClick={() => setOpenness(pct)}
                className={`py-2 rounded-lg text-sm font-medium border transition-colors ${
                  active ? 'bg-amber-600 text-white border-amber-600' :
                  available ? 'bg-white text-neutral-700 border-neutral-200 hover:border-amber-400' :
                  'bg-neutral-50 text-neutral-300 border-neutral-100 cursor-not-allowed line-through'
                }`}
                data-testid={`openness-${pct}`}
              >
                {pct}%
              </button>
            );
          })}
        </div>
        <p className="text-[10px] text-neutral-400">Higher openness lets more light and view through the weave.</p>
      </div>
    );
  }

  return (
    <div className="space-y-1.5" data-testid="filtering-controls">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <SunDim className="w-4 h-4 text-amber-500" />
          <label className="text-[11px] text-neutral-500 uppercase tracking-wider font-medium">Light Filtering Level</label>
        </div>
        <span className="text-[10px] px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 font-medium">{light.label}</span>
      </div>
      <input
        type="range" min="0.5" max="1" step="0.01"
        value={filterOpacity}
        onChange={e => setFilterOpacity(parseFloat(e.target.value))}
        className="w-full accent-amber-600 h-1.5"
        data-testid="opacity-slider"
      />
      <div className="flex justify-between text-[10px] text-neutral-400">
        <span>More light</span>
        <span>{Math.round(filterOpacity * 100)}%</span>
        <span>More privacy</span>
      </div>
    </div>
  );
};

export default LightControls;
